import moment from 'moment';

import templateUrl from './posted-payouts-dashboard-container.component.html';
import './posted-payouts-dashboard.component.less';
import { containsInvariant } from '../../../../../core/services/filter-util';
import { DivisionEnum } from '../../../../../core/services/data-services/division.service';

export const PostedPayoutsDashboardContainerComponent = {
    controller: PostedPayoutsDashboardContainerController,
    controllerAs: "vm",
    templateUrl
};

function PostedPayoutsDashboardContainerController($q, divisionService, employeeService,
    icdCorporationService, postedPayoutService, utilityService,
    apexApiUrl, rogersPayoutReportService) {
    'ngInject';

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    vm.$onInit = onInit;
    vm.divisions;
    vm.filters = {};
    vm.repFilters = {};
    vm.icdCorporations;
    vm.productLines;
    vm.products;
    vm.loaded = false;
    vm.onRefresh = onRefresh
    vm.onSelectPayout = onSelectPayout;
    vm.onChangeDivision = onChangeDivision;
    vm.postedPayouts;
    vm.repsPostedPayouts;
    vm.postedPayoutsDetails;
    vm.filterRepsPostedPayouts = filterRepsPostedPayouts;
    vm.onChangeTab = onChangeTab;
    vm.onExport = onExport;
    vm.onExportExceptionsReport = onExportExceptionsReport;
    vm.dropdownOptions = {
        dataSource: new kendo.data.DataSource({
            data: vm.icdCorporations,
        }),
    }
    vm.reportTypes = [
        {
            Id: 1,
            Name: "Posted Payout Report"
        },
        {
            Id: 3,
            Name: "Posted Payout Report (Including Credits)"
        }
    ];
    //Select the Including Credits report as a default report type
    vm.filters.selectedReportType = vm.reportTypes[1];

    function onInit() {
        // Automatically load data for the last week.
        vm.filters.startDate = moment().subtract(1, "month").startOf("day").toDate();
        vm.filters.endDate = moment().startOf("day").toDate();
        const dataLoaded = loadInitialData()
            .then(function () {
                vm.filters.division = vm.divisions.length === 1 ? vm.divisions[0] : null;
                if (vm.filters.division != null) {
                    updateIcdCorporations(vm.filters.division ? vm.filters.division.Id : null);
                }
            });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(dataLoaded, "Initial load failed")
                .then(() => vm.loaded = true));
    }

    function onChangeTab() {
        vm.workOrderPayoutBreakdown = null;
        vm.repWorkOrderPayoutsBreakdown = null;
    }

    function onRefresh() {
        vm.selectedPayout = null;
        vm.loaded = false;
        vm.showRogersReport = vm.filters.division.Id === divisionService.divisionIDs.Rogers;
        // Keep track of the currently selected filters to keep the interface consistent.
        vm.selectedIcdCorporation = vm.filters.icdCorporation;
        vm.selectedDivision = vm.filters.division;

        const postedPayoutsLoaded = loadIcdPayouts()
            .then(selectDefaultIcdPayout)
            .then(function () {
                if (vm.selectedPayout) {
                    return loadPostedPayoutsDetails(vm.selectedPayout);
                }
            })
            .then(() => vm.divisionPayouts = createDivisionPayoutsFromIcdPayouts(vm.postedPayouts));

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(postedPayoutsLoaded, "Refresh failed"))
            .then(() => vm.loaded = true);
    }

    function onSelectPayout(postedPayout) {
        const loaded = loadPostedPayoutsDetails(postedPayout)
            .then(function () {
                vm.selectedPayout = postedPayout;
            });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loaded, "Additional data load failed"));
    }

    function onChangeDivision() {
        updateIcdCorporations(vm.filters.division.Id);
    }

    function updateIcdCorporations(divisionID) {
        // Only display corporations for which the user is a payout module admin.
        const corporations = icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Payout", { divisionId: divisionID })
            .then(function (icdCorporations) {
                vm.icdCorporations = icdCorporations;
                vm.icdCorporations.forEach(formatIcdCorporation);
                vm.filters.icdCorporation = vm.icdCorporations.length === 1 ? vm.icdCorporations[0] : null;
                onRefresh();
                return icdCorporations.sort(function (a, b) {
                    return a.Owner < b.Owner ? -1 : 1;
                });
            });
                


        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(corporations, "Loading corporation failed"));
    }

    function formatIcdCorporation(icdCorporation) {
        icdCorporation.OwnerClientName = icdCorporation.Owner + " - " + icdCorporation.ClientName;
    }

    function loadInitialData() {

        const divisionsLoaded = divisionService.retrieveDivisions()
            .then(function (divisions) {
                vm.divisions = divisions.filter(function (division) {
                    // Filter to only display divisions that use product commissions.
                    return division.UseProductCommissionPolicy;
                });
                return vm.divisions;
            });

        const identityLoaded = employeeService.retrieveIdentity()
            .then(identity => {
                vm.identity = identity;
                vm.isInnovageAdmin = identity.IsSiteAdmin || identity.Roles.reduce((any, role) =>
                    any || role === "Innovage Payout", false);
            });

        return $q.all([divisionsLoaded, identityLoaded]);
    }

    function loadIcdPayouts() {
        const icdCorporationID = vm.filters.icdCorporation ? vm.filters.icdCorporation.Id : null;
        const divisionID = vm.filters.division ? vm.filters.division.Id : null;
        return postedPayoutService.retrieveIcdPayouts(vm.filters.startDate,
            vm.filters.endDate, divisionID, icdCorporationID)
            .then(function (icdPayouts) {
                icdPayouts.forEach(function (icdPayout) {
                    icdPayout.IcdCorporation = vm.icdCorporations.filter(function (icdCorporation) {
                        return icdCorporation.Id === icdPayout.IcdCorporationID;
                    })[0];
                    hydratePayoutTotals(icdPayout);
                });
                return icdPayouts;
            })
            .then(function (postedPayouts) {
                vm.postedPayouts = postedPayouts;
                return postedPayouts;
            })
            .then(function () {
                if (vm.selectedPayout) {
                    loadPostedPayoutsDetails(vm.selectedPayout);
                }
            });
    }

    function createDivisionPayoutsFromIcdPayouts(icdPayouts) {
        return icdPayouts.reduce((divisionPayouts, icdPayout) => {
            const added = divisionPayouts.reduce((any, payout) =>
                any || moment(payout.PostedDate).isSame(icdPayout.PostedDate), false);
            if (!added) {
                divisionPayouts.push({
                    Division: vm.filters.division,
                    PostedDate: icdPayout.PostedDate
                })
            }
            return divisionPayouts;
        }, []).sort((a, b) => moment(a.PostedDate).isBefore(b.PostedDate) ? 1 : -1);
    }

    /**
     * Update the payment amount totals for the given payout posting
     * based on its components.
     * @param {any} payout A posted payout consisting of the components of the payout totals.
     */
    function hydratePayoutTotals(payout) {
        payout.PayoutAmount = 0;
        payout.WorkOrderPayouts.forEach(function (workOrderPayout) {
            workOrderPayout.PayoutAmount = workOrderPayout.ProductPayouts.reduce(function (sum, payout) {
                return sum + payout.PayoutAmount;
            }, 0) + workOrderPayout.MultiPlayPayouts.reduce(function (sum, payout) {
                return sum + payout.PayoutAmount;
            }, 0);
            payout.PayoutAmount += workOrderPayout.PayoutAmount;
        });
    }

    /**
     * Load the full payout report into the given ICD payout posting.
     * @param {any} postedPayout
     */
    function loadPostedPayoutsDetails(postedPayout) {
        if (postedPayout.payoutReport) {
            return $q.when(postedPayout.payoutReport);
        }

        if (vm.filters.division.Id === divisionService.divisionIDs.Rogers) {
            // Load a report filtered by the selected posting.
            const postedDate = postedPayout.PostedDate;
            return rogersPayoutReportService.retrieveRogersPostedPayoutReport({
                DivisionID: vm.filters.division.Id,
                IcdCorporationID: postedPayout.IcdCorporationID,
                ShowLoggedInUserWorkOrders: !vm.identity.IsSiteAdmin && !postedPayout.IcdCorporationID,
                PostedDate: postedDate,
                Comparison: vm.filters.selectedReportType ? vm.filters.selectedReportType.Id : null
            }).then(function (payoutReport) {
                postedPayout.payoutReport = payoutReport;
            });
        }
    }

    function onExport() {
        let query;
        let queryString;
        switch (vm.filters.division.Id) {
            case divisionService.divisionIDs.Rogers:
                query = {
                    DivisionID: vm.filters.division.Id,
                    IcdCorporationID: vm.filters.icdCorporation ? vm.filters.icdCorporation.Id : null,
                    PostedStartDate: vm.filters.startDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.startDate) : null,
                    PostedEndDate: vm.filters.endDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.endDate) : null,
                    Comparison: vm.filters.selectedReportType ? vm.filters.selectedReportType.Id : null
                };
                queryString = utilityService.queryStringify(query);
                window.location.href = apexApiUrl + "reports/rogers/posted-payout-report.xlsx" + queryString;
        }
    }

    function onExportExceptionsReport() {
        switch (vm.filters.division.Id) {
            case DivisionEnum.Rogers: {
                const query = {
                    PostedDate: moment(vm.selectedPayout.PostedDate).format("YYYY-MM-DD"),
                    IcdCorporationID: vm.selectedPayout.IcdCorporationID
                }
                const queryString = utilityService.queryStringify(query);
                window.location.href = apexApiUrl + "reports/rogers/posted-payout-exceptions-report.xlsx" + queryString;
                break;
            }
        }
    }

    function selectDefaultIcdPayout() {
        if (vm.postedPayouts.length > 0 && vm.icdCorporations.length > 0) {
            const defaultIcdPayout = vm.postedPayouts.filter(function (icdPayout) {
                return icdPayout.Visible;
            })[0];


            if (defaultIcdPayout) {
                vm.selectedPayout = defaultIcdPayout;
            }
        }
    }

    function filterRepsPostedPayouts(payout) {

        return (!vm.repFilters.EmployeeName || containsInvariant(payout.EmployeeName, vm.repFilters.EmployeeName))
            && (!vm.repFilters.PostedDate || moment(vm.repFilters.PostedDate).isSame(payout.PostedDate))

    }
}
